import { endPoints } from "../utils/constanst";
import http from "./http";

const createOportunity = async (data) => {

    return new Promise((resolve, reject) => {       

        http(endPoints.createOportunity).post(data).then(response => {
            //console.log(response);
            resolve(response);
        }).catch(error => {
            //console.log(error);
            reject(error);
        });

    })

}

export default createOportunity